<script>
import axios from '@/utils/axios';
import { logoutUser } from '@/utils/auth';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],
data() {
 return {
  title: "Profile",
  text: "Pages",
  text1: "Profile",
  showPassword: false,
  showPassword1: false,
  showPassword2: false,
  toast: useToast(),
  profile_image: null,
  form:{
   name: '',
   email: '',
   mobile: '',
   parent_id: '',
  },
  current_password: '',
  new_password: '',
  password_confirmation: '',
  profile_preview: null,
  errors: {}
 };
},
 computed: {
  buttonLabel() {
   return this.showPassword ? "Hide" : "Show";
  },
  buttonLabel1() {
   return this.showPassword1 ? "Hide" : "Show";
  },
  buttonLabel2() {
   return this.showPassword2 ? "Hide" : "Show";
  },

},

async mounted(){
 this.form.name = this.auth.name;
 this.form.email = this.auth.email;
 this.form.mobile = this.auth.mobile; 
 this.form.parent_id = this.auth.parent_id;
 this.profile_preview = this.auth?.image ? this.auth?.image_url : null;
},
methods: {
 toggleShow() {
  this.showPassword = !this.showPassword;
 },
 toggleShow1() {
  this.showPassword1 = !this.showPassword1;
 },
 toggleShow2() {
  this.showPassword2 = !this.showPassword2;
 },

handleImageUpload(event) {
  const file = event.target.files[0];
  this.profile_image = file;
  if(file){
    this.profile_preview = URL.createObjectURL(file);
  }else{
    this.profile_preview = this.auth?.image ? this.auth?.image_url : null;
  }
},

 async updateProfile(){
  this.errors = {};
  this.setLoading(true);
  try{
   const formData = new FormData();
   formData.append('name', this.form.name);
   formData.append('email', this.form.email);
   formData.append('mobile', this.form.mobile);
   formData.append('parent_id', this.form.parent_id);
   if(this.profile_image){
    formData.append('image', this.profile_image);
   }

   const response = await axios.post('/setting/profile/update', formData, {
    headers: { 'Content-Type': 'multipart/form-data',},
   });

   const user = response.data.data;
   localStorage.setItem('auth_user', JSON.stringify(user));

   this.toast.success('Profile updated!');
  }catch(error){
   if(error.type == 'validation'){
    this.errors = error.errors;
   }else{
    this.toast.error(error.message);
   }
  }finally{
   this.setLoading(false); 
  }
 },

 async changePassword(){
  this.errors = {};
  this.setLoading(true);
  try{
   const response = await axios.post('/setting/change-password', {
    current_password: this.current_password,
    new_password: this.new_password,
    new_password_confirmation: this.password_confirmation
   });

   logoutUser(); 
   this.toast.success(response.data.message);
   this.$router.push('/');

  }catch(error){
   if(error.type == 'validation'){
    this.errors = error.errors;
   }else{
    this.toast.error(error.message);
   }
  }finally{
   this.setLoading(false);
  }
 }

},
};
</script>

<template>
<layout-sidebar></layout-sidebar>
<layout-header></layout-header>
<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
</div>
<!-- /Breadcrumb -->

<div class="row">

 <div class="col-lg-8">
<div class="card">
<div class="card-body">
<div class="border-bottom mb-3 pb-3">
  <h4>Profile</h4>
</div>
<form @submit.prevent="updateProfile" enctype="multipart/form-data">
  <div class="border-bottom mb-3">
<div class="row">
  <div class="col-md-12">
  <div>
    
    <div class="d-flex align-items-center mb-3 flex-wrap justify-content-between gap-2">
    <h6 class="mb-0 fw-semibold">Basic Information</h6>
    <div class="d-flex align-items-center gap-2" v-if="auth?.uuid">
     <span class="badge bg-light text-primary border px-3 py-2">UUID: {{ auth.uuid }}
     <a href="javascript:void(0);" class="text-muted ms-1" title="Copy UUID" @click="$copyText(auth.uuid)">
      <i class="ti ti-copy"></i>
     </a>
     </span>
    </div>
    </div>


    <div class="d-flex align-items-center gap-3 flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
     <img v-if="profile_preview" :src="profile_preview" width="50" />
      <i v-else class="ti ti-user-circle fs-40 text-muted"></i>
      <div class="profile-upload">
        <div class="mb-2">
          <h6 class="mb-1">Profile Photo</h6>
          <p class="fs-12">Recommended image size is 40px x 40px</p>
        </div>
        <div class="profile-uploader d-flex align-items-center">
          <div class="drag-upload-btn btn btn-sm btn-primary me-2">
            Upload
          <input type="file" class="form-control image-sign" @change="handleImageUpload" />
          </div>
          <div v-if="errors.image" class="text-danger small mt-1">{{ errors.image[0] }}</div>
        </div>
      </div>
    </div>
  </div>
  </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label class="form-label mb-md-0">Full Name</label>
        <input type="text" class="form-control" v-model="form.name" />
        <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
      </div>
      <div class="col-md-5">
        <label class="form-label mb-md-0">Email ID</label>
        <input type="text" class="form-control" v-model="form.email" />
        <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
      </div>
      <div class="col-md-3">
        <label class="form-label mb-md-0">Phone No</label>
        <input type="text" class="form-control" v-model="form.mobile" />
        <div v-if="errors.mobile" class="text-danger small mt-1">{{ errors.mobile[0] }}</div>
      </div>
    </div>
  </div>
  
  <div class="d-flex align-items-center justify-content-end">
    <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>
</div>
</div>
</div>

 <div class="col-lg-4">
<div class="card">
<div class="card-body">
<div class="border-bottom mb-3 pb-3">
  <h4>Change Password</h4>
</div>
<form @submit.prevent="changePassword">
  <div class="border-bottom mb-3">

  <div class="row">
  <div class="col-md-12 mb-3">
    <label class="form-label mb-md-0">Current Password</label>
    <div class="pass-group">
   <input :type="showPassword ? 'text' : 'password'" class="pass-input form-control" placeholder="Current Password" v-model="current_password" />
   <span @click="toggleShow" class="ti toggle-password"
    :class="{
      'ti-eye': showPassword,
      'ti-eye-off': !showPassword,
    }"></span>
  </div>
  <div v-if="errors.current_password" class="text-danger small mt-1">{{ errors.current_password[0] }}</div>
  </div>
  <div class="col-md-12 mb-3">
    <label class="form-label mb-md-0">New Password</label>
    <div class="pass-group">
    <input :type="showPassword1 ? 'text' : 'password'" class="pass-inputs form-control" placeholder="New Password" v-model="new_password"/>
    <span @click="toggleShow1" class="ti toggle-passwords"
     :class="{
      'ti-eye': showPassword1,
      'ti-eye-off': !showPassword1,
    }"></span>
  </div>
  <div v-if="errors.new_password" class="text-danger small mt-1">{{ errors.new_password[0] }}</div>
  </div>
  <div class="col-md-12 mb-3">
    <label class="form-label mb-md-0">Confirm Password</label>
    <div class="pass-group">
   <input :type="showPassword2 ? 'text' : 'password'" class="pass-inputs form-control" placeholder="Confirm Password" v-model="password_confirmation"/>
   <span @click="toggleShow2" class="ti toggle-passwords"
    :class="{
     'ti-eye': showPassword2,
     'ti-eye-off': !showPassword2,
    }"></span>
  </div>

  </div>
  </div>
  </div>

  <div class="d-flex align-items-center justify-content-end">
   <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>
</div>
</div>
</div>

</div>

</div>
<app-footer></app-footer>
</div>
<!-- /Page Wrapper -->
</template>

